module.exports = __webpack_public_path__ + "images/stickers/pete-happy@2x.0663bc183a0cf0d03949.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-happy@2x.png
// module id = PbvX
// module chunks = 2